import mProductCard309 from "../../Product/Card/ProductCard309";
import mProductCard903 from "../../Product/Card/ProductCard903";
import mProductCard903s from "../../Product/Card/ProductCard903s";
import mProductCard912 from "../../Product/Card/ProductCard912.vue";
import mProductCard310 from "../../Product/Card/ProductCard310.vue";
import mProductCard922 from "../../Product/Card/ProductCard922.vue";
import mProductCard450 from "../../Product/Card/ProductCard450.vue";
import mProductCard516 from "./ProductCard516.vue";
import mProductCard201 from "../../Product/Card/ProductCard201.vue";
import mProductCard200 from "../../Product/Card/ProductCard200.vue";
import mProductCard302 from "./ProductCard302/ProductCard302.vue";
import mProductCard311 from "../../Product/Card/ProductCard311.vue";
import mProductCard312 from "../../Product/Card/ProductCard312.vue";
import mProductCard207 from "../../Product/Card/ProductCard207.vue";
import mProductCard3_1 from "../../Product/Card/ProductCard3_1.vue";
import mProductCard309Dashboard from "../../Product/Card/ProductCard309Dashboard.vue";
import mProductCard208 from "./ProductCard208/ProductCard208.vue";
import mProductCard3_variation from "./ProductCard3_variation.vue";
import mProductCard207_price from "../../Product/Card/ProductCard207_price.vue";
import mProductCard207_quantity from "./ProductCard207Quantity/ProductCard207_quantity.vue";
import mProductCard208_request from "././ProductCard208_request/ProductCard208_request.vue";
import mProductCard313 from "././ProductCard313/ProductCard313.vue";
import mProductCard207_modal from "../../Product/Card/ProductCard207_Modal.vue";
import mProductCard902 from "../../Product/Card/ProductCard902.vue";
import mProductCard208_variation_without_image
    from "../../Product/Card/ProductCard208_variation_without_image/ProductCard208_variation_without_image.vue";
import ProductCard3_1_edit_button from "../../Product/Card/ProductCard3_1_edit_button.vue";
import mProductCard500 from "../../Product/Card/ProductCard500/ProductCard500.vue";
import mProductCard501 from "../../Product/Card/ProductCard501/ProductCard501.vue";
import mProductCard207_subscription from "../../Product/Card/ProductCard207_subscription.vue";
import mProductCard502_quantity from "./ProductCard502Quantity/ProductCard502_quantity.vue";
import mProductCard500_subscription from "../Card/ProductCard500_subscription/ProductCard500_subscription.vue";
import mProductCard310_Category from "../Card/ProductCard310_Category.vue";





export const Cards = {
    mProductCard309,
    mProductCard903,
    mProductCard903s,
    mProductCard912,
    mProductCard310,
    mProductCard922,
    mProductCard450,
    mProductCard516,
    mProductCard201,
    mProductCard200,
    mProductCard302,
    mProductCard311,
    mProductCard312,
    mProductCard207,
    mProductCard309Dashboard,
    mProductCard3_1,
    mProductCard208,
    mProductCard3_variation,
    mProductCard207_price,
    mProductCard207_quantity,
    mProductCard208_request,
    mProductCard313,
    mProductCard207_modal,
    mProductCard902,
    mProductCard208_variation_without_image,
    ProductCard3_1_edit_button,
    mProductCard500,
    mProductCard501,
    mProductCard207_subscription,
    mProductCard502_quantity,
    mProductCard500_subscription,
    mProductCard310_Category,

}